import { addToEndOfChain, addToStartOfChain, Handler } from "@insite/client-framework/HandlerCreator";
import loadQuote, { chain } from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";
import { QuoteModel } from "@insite/client-framework/Types/ApiModels";
import { CustomApiHandler } from "@tJohnstonCompanies/Handlers/CustomHandlerCreator";

type HandlerType = CustomApiHandler<any, QuoteModel>;

export const EmptyCustomState: HandlerType = props => {
    if (!props?.parameter?.isMessageApi) {
        props.dispatch({
            type: "Custom/RfqQuoteDetailsNew/SetAccountNumber",
            accountNumber: undefined,
        });
        props.dispatch({
            type: "Custom/RfqQuoteDetailsNew/SetShipVia",
            shipVia: undefined,
        });
        props.dispatch({
            type: "Custom/RfqQuoteDetailsNew/SetCarrier",
            carrier: undefined,
            iseditable: false,
        });
    }
};

addToStartOfChain(chain, EmptyCustomState as Handler);
